import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
   apiKey: "AIzaSyB-dQ4hnidZll2kXMozkJ65eOiCUP6ND34",
  authDomain: "ecoomerce-perfume.firebaseapp.com",
  projectId: "ecoomerce-perfume",
  storageBucket: "finance-96d92.appspot.com",
  messagingSenderId: "702219574504",
  appId: "1:702219574504:web:868b14e791142e05ec7d5d"
};

const vapidKey = "BAr0M8CQ_WBLt-gE0FF3lDiTfraht56G-IIJd_b_tPtGMy_q80zHOgNXEqd4QuX3ApVp9RGXFXYJF3rvpQ9qq0U";

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export const requestFCMToken = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.warn("Notification permission not granted.");
      return null;
    }

    const swRegistration = await navigator.serviceWorker.register("/firebase-messaging-sw.js");

    const token = await getToken(messaging, {
      vapidKey,
      serviceWorkerRegistration: swRegistration,
    });

    return token;
  } catch (err) {
    console.error("❌ Error getting FCM token:", err);
    return null;
  }
};

export const listenToForegroundMessages = () => {
  onMessage(messaging, (payload) => {
    const title =
      payload?.notification?.title ||
      payload?.data?.title ||
      "Beentara";
    const body =
      payload?.notification?.body ||
      payload?.data?.body ||
      "You have a new notification";

    if (typeof Notification !== "undefined" && Notification.permission === "granted") {
      const url = payload?.data?.url || "/crm";
      const options = {
        body,
        icon: "/logo192.png",
        data: { url },
      };
      navigator.serviceWorker?.ready
        .then((reg) => reg.showNotification(title, options))
        .catch(() => new Notification(title, options));
      return;
    }

    if (payload?.notification) {
      alert(`${title}: ${body}`);
    }
  });
};
